import Favorite from '../src/Favorite/index';
export default Favorite;
